<div class="not-auth-container">
  <i class="i-lock-red lock-icon mb-3"></i>

  <h2 class="font-600">Denna profil är privat</h2>
  <p class="text-muted">Du har inte behörighet att visa denna sida.</p>

  <div class="d-flex gap-2 mt-3">
    <button class="btn btn-secondary" (click)="goBack()">
      ← Tillbaka
    </button>

    <button class="btn btn-primary" (click)="goHome()">
      Gå till startsidan
    </button>
  </div>
</div>
